export default {
	
	init(globals){
		return (key,defaultText)=>{
			return (globals.i18n && globals.i18n[key]) || defaultText;
		};
	},

};